"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostInfoSchema = exports.ErrorCodeSchema = exports.DateSchema = exports.UUIDSchema = exports.PaginationSchema = exports.ApiResponseSchema = void 0;
const zod_1 = require("zod");
// Common Response Wrapper
exports.ApiResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    data: zod_1.z.any().optional(),
    error: zod_1.z.string().optional(),
    meta: zod_1.z.object({
        timestamp: zod_1.z.string(),
        requestId: zod_1.z.string(),
        version: zod_1.z.string().default('v1'),
    }),
});
// Pagination
exports.PaginationSchema = zod_1.z.object({
    page: zod_1.z.number().min(1).default(1),
    limit: zod_1.z.number().min(1).max(100).default(20),
    total: zod_1.z.number().optional(),
    totalPages: zod_1.z.number().optional(),
});
// UUID Schema
exports.UUIDSchema = zod_1.z.string().uuid();
// Date Schema
exports.DateSchema = zod_1.z.string().datetime();
// Common Error Types
exports.ErrorCodeSchema = zod_1.z.enum([
    'VALIDATION_ERROR',
    'AUTHENTICATION_ERROR',
    'AUTHORIZATION_ERROR',
    'RATE_LIMIT_EXCEEDED',
    'RESOURCE_NOT_FOUND',
    'INTERNAL_SERVER_ERROR',
    'AI_SERVICE_ERROR',
    'SUBSCRIPTION_REQUIRED',
    'DAILY_LIMIT_EXCEEDED',
]);
// Cost Tracking
exports.CostInfoSchema = zod_1.z.object({
    modelUsed: zod_1.z.string(),
    estimatedCostCents: zod_1.z.number(),
    processingTimeMs: zod_1.z.number(),
    fromCache: zod_1.z.boolean(),
});
//# sourceMappingURL=common.js.map